import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Loader2, ScrollText } from "lucide-react";
import { PageHeader, fmtDateTime, Empty } from "../../components/admin/ui";

const Logs = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/logs").then((r) => setItems(r.data.items || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-8" data-testid="admin-logs">
      <PageHeader
        overline="Accountability"
        title={<><span className="italic gold-text">Activity</span> logs</>}
        subtitle="A record of every administrative action — for the integrity of the ministry."
      />

      {loading ? (
        <div className="text-[#D9D9D9]/60"><Loader2 className="inline h-4 w-4 animate-spin mr-2" /> Loading…</div>
      ) : items.length === 0 ? (
        <Empty title="No activity yet" subtitle="As you publish, log donations, and manage media, entries appear here." />
      ) : (
        <div className="bento-card !p-0 overflow-hidden">
          <span className="glow-blob" />
          <ul className="divide-y divide-[#C9A44C]/10">
            {items.map((l) => (
              <li key={l.id} className="px-6 py-4 flex items-start justify-between gap-4">
                <div className="flex items-start gap-3 min-w-0">
                  <ScrollText className="h-4 w-4 text-[#C9A44C]/70 mt-1 flex-shrink-0" />
                  <div className="min-w-0">
                    <div className="text-sm text-[#F6F0E6]">{l.action.replace(/_/g, " ")} {l.resource_type && <span className="text-[#D9D9D9]/60">· {l.resource_type}</span>}</div>
                    <div className="text-[11px] text-[#D9D9D9]/60 mt-0.5 truncate">{l.admin_email} {l.resource_id && `· id:${l.resource_id}`}</div>
                  </div>
                </div>
                <div className="text-[11px] text-[#D9D9D9]/60 whitespace-nowrap">{fmtDateTime(l.created_at)}</div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Logs;
